import getQuickComposeViewState from './getQuickComposeViewState';

export default function isQuickComposeViewTypeAssetNewEvent(): boolean {
    return getQuickComposeViewState().viewType == 'CalendarAssetNewEventButton';
}
